import { render, staticRenderFns } from "./NewTruckModal.vue?vue&type=template&id=538827ca"
import script from "./NewTruckModal.vue?vue&type=script&lang=ts"
export * from "./NewTruckModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports